import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { id: "form" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 mb-2 text-end" }
const _hoisted_6 = { class: "col-12 mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_8 = { class: "col-12 mt-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_11 = {
  key: 1,
  class: "flaticon-cloud-computing me-2"
}
const _hoisted_12 = {
  key: 0,
  class: "card mt-4 mb-20"
}
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table" }
const _hoisted_16 = { class: "table-header" }
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["onUpdate:modelValue", "onInput"]
const _hoisted_29 = { class: "invalid-feedback text-center" }
const _hoisted_30 = ["onUpdate:modelValue", "onInput"]
const _hoisted_31 = { class: "invalid-feedback" }
const _hoisted_32 = ["onUpdate:modelValue", "onInput"]
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = {
  key: 0,
  class: "d-flex gap-1 mt-1"
}
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "form-check form-switch d-inline-block" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_42 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_43 = { class: "text-primary fw-bold fs-13" }
const _hoisted_44 = {
  class: "progress",
  style: {"height":"10px"}
}
const _hoisted_45 = ["aria-valuenow"]
const _hoisted_46 = { class: "mt-3 text-end" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", { class: "card-title mb-0" }, "Nouveau Colis (Stock)")
      ], -1)),
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.importModel && _ctx.importModel(...args)))
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "flaticon-cloud-computing me-2" }, null, -1),
                _createElementVNode("span", null, "Télecharger Un modèle", -1)
              ]))
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", {
              class: "alert alert-info border-0 rounded-0",
              role: "alert"
            }, [
              _createElementVNode("h6", { class: "alert-heading fw-bold" }, [
                _createElementVNode("i", { class: "bi bi-info-circle me-2" }),
                _createTextVNode("Format d'importation des produits ")
              ]),
              _createElementVNode("p", { class: "mb-0 fs-14" }, [
                _createTextVNode(" Utilisez le format suivant : "),
                _createElementVNode("strong", null, "REF1:QNT1 / REF2:QNT2")
              ]),
              _createElementVNode("hr"),
              _createElementVNode("ul", { class: "mb-0 fs-13" }, [
                _createElementVNode("li", null, [
                  _createTextVNode("Séparez les produits par un slash ("),
                  _createElementVNode("strong", null, "/"),
                  _createTextVNode(").")
                ]),
                _createElementVNode("li", null, [
                  _createTextVNode(" Séparez la référence et la quantité par deux points ("),
                  _createElementVNode("strong", null, ":"),
                  _createTextVNode("). ")
                ]),
                _createElementVNode("li", null, [
                  _createTextVNode(" Si la quantité est omise (ex: "),
                  _createElementVNode("strong", null, "REF1"),
                  _createTextVNode("), elle sera fixée à "),
                  _createElementVNode("strong", null, "1"),
                  _createTextVNode(" par défaut. ")
                ])
              ])
            ], -1)),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("hr")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("input", {
                type: "file",
                class: "form-control",
                accept: ".xlsx,.xls",
                name: "file_import",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
              }, null, 32),
              (_ctx.import_file && _ctx.import_file.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createTextVNode(" Le fichié Importé: ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.import_file.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-success",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ImportColis && _ctx.ImportColis(...args))),
                disabled: _ctx.load || !_ctx.import_file
              }, [
                (_ctx.load)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                  : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                _createElementVNode("span", null, _toDisplayString(_ctx.load ? "Importation en cours..." : "Enregistrer les colis"), 1)
              ], 8, _hoisted_9),
              (_ctx.import_file)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-danger ms-3",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.RemoveFile && _ctx.RemoveFile(...args)))
                  }, _cache[9] || (_cache[9] = [
                    _createElementVNode("i", { class: "flaticon-delete me-2" }, null, -1),
                    _createElementVNode("span", null, "Supprimer le fichier importé", -1)
                  ])))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.ListColis.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "card-title mb-0" }, "Nouveaux Colis")
          ], -1)),
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.SaveColis && _ctx.SaveColis(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_16, [
                      _cache[15] || (_cache[15] = _createElementVNode("th", null, "Code suivi", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("th", null, "Destinataire", -1)),
                      _cache[17] || (_cache[17] = _createElementVNode("th", null, "Téléphone", -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("th", null, "Adresse", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("th", null, "Prix", -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("th", null, "Ville", -1)),
                      _cache[21] || (_cache[21] = _createElementVNode("th", null, "Commentaire", -1)),
                      _cache[22] || (_cache[22] = _createElementVNode("th", null, "Réf Produits", -1)),
                      _cache[23] || (_cache[23] = _createElementVNode("th", null, "Type Colis", -1)),
                      _createElementVNode("th", _hoisted_17, [
                        _cache[14] || (_cache[14] = _createElementVNode("small", { class: "d-block text-muted mb-1" }, "Ouvrir", -1)),
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select form-select-sm shadow-none",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.open) = $event)),
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.AllOpen()))
                        }, _cache[13] || (_cache[13] = [
                          _createElementVNode("option", { value: 1 }, "Oui", -1),
                          _createElementVNode("option", { value: 0 }, "Non", -1)
                        ]), 544), [
                          [_vModelSelect, _ctx.open]
                        ])
                      ]),
                      _cache[24] || (_cache[24] = _createElementVNode("th", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ListColis, (coli, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.code_suivi) = $event)
                          }, null, 8, _hoisted_18), [
                            [_vModelText, coli.code_suivi]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["form-control", { 'is-invalid': !coli.destinataire }]),
                            "onUpdate:modelValue": ($event: any) => ((coli.destinataire) = $event),
                            required: ""
                          }, null, 10, _hoisted_19), [
                            [_vModelText, coli.destinataire]
                          ]),
                          (!coli.destinataire)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Champ requis "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: _normalizeClass(["form-control", {
                      'is-invalid':
                        !coli.telephone || coli.telephone.length !== 10,
                    }]),
                            "onUpdate:modelValue": ($event: any) => ((coli.telephone) = $event),
                            required: "",
                            maxlength: "10"
                          }, null, 10, _hoisted_21), [
                            [_vModelText, coli.telephone]
                          ]),
                          (!coli.telephone || coli.telephone.length !== 10)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Téléphone invalide "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: _normalizeClass(["form-control", { 'is-invalid': !coli.adresse }]),
                            "onUpdate:modelValue": ($event: any) => ((coli.adresse) = $event),
                            required: ""
                          }, null, 10, _hoisted_23), [
                            [_vModelText, coli.adresse]
                          ]),
                          (!coli.adresse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Champ requis "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            class: _normalizeClass(["form-control", {
                      'is-invalid':
                        coli.error_price || !coli.prix || coli.prix < 0,
                    }]),
                            "onUpdate:modelValue": ($event: any) => ((coli.prix) = $event),
                            required: ""
                          }, null, 10, _hoisted_25), [
                            [_vModelText, coli.prix]
                          ]),
                          (coli.error_price || !coli.prix || coli.prix < 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Prix invalide "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_v_select, {
                            id: 'city' + index,
                            style: _normalizeStyle([
                      coli.error_city ? { border: '1px solid red' } : '',
                    ]),
                            modelValue: coli.city,
                            "onUpdate:modelValue": ($event: any) => ((coli.city) = $event),
                            options: _ctx.CitiesList,
                            label: "ville",
                            onInput: ($event: any) => (_ctx.GetId(coli, index))
                          }, null, 8, ["id", "style", "modelValue", "onUpdate:modelValue", "options", "onInput"])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => ((coli.commentaire) = $event)
                          }, null, 8, _hoisted_27), [
                            [_vModelText, coli.commentaire]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          (coli.message)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "form-control is-invalid",
                                  "onUpdate:modelValue": ($event: any) => ((coli.ref_produits) = $event),
                                  onInput: ($event: any) => (_ctx.GetIdRef(coli, index, coli.ref_produits)),
                                  required: ""
                                }, null, 40, _hoisted_28), [
                                  [_vModelText, coli.ref_produits]
                                ]),
                                _createElementVNode("div", _hoisted_29, _toDisplayString(coli.ref) + " et/ou qnty est invalide ", 1)
                              ], 64))
                            : (coli.refError)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control is-invalid",
                                    "onUpdate:modelValue": ($event: any) => ((coli.ref_produits) = $event),
                                    onInput: ($event: any) => (_ctx.GetIdRef(coli, index, coli.ref_produits)),
                                    required: ""
                                  }, null, 40, _hoisted_30), [
                                    [_vModelText, coli.ref_produits]
                                  ]),
                                  _createElementVNode("div", _hoisted_31, " Aucun produit avec ce réf :" + _toDisplayString(coli.refError), 1)
                                ], 64))
                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 2,
                                  type: "text",
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => ((coli.ref_produits) = $event),
                                  onInput: ($event: any) => (_ctx.GetIdRef(coli, index, coli.ref_produits)),
                                  required: ""
                                }, null, 40, _hoisted_32)), [
                                  [_vModelText, coli.ref_produits]
                                ])
                        ]),
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-select form-select-sm", { 'text-primary fw-bold': coli.replace != 0 }]),
                            "onUpdate:modelValue": ($event: any) => ((coli.replace) = $event)
                          }, _cache[25] || (_cache[25] = [
                            _createElementVNode("option", { value: 0 }, "Simple", -1),
                            _createElementVNode("option", { value: 1 }, "Change", -1)
                          ]), 10, _hoisted_33), [
                            [_vModelSelect, coli.replace]
                          ]),
                          (coli.replace == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control form-control-sm px-1 text-center",
                                  placeholder: "Env",
                                  "onUpdate:modelValue": ($event: any) => ((coli.nbr_sent) = $event),
                                  title: "Nombre envoyé"
                                }, null, 8, _hoisted_35), [
                                  [_vModelText, coli.nbr_sent]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: "form-control form-control-sm px-1 text-center",
                                  placeholder: "Ret",
                                  "onUpdate:modelValue": ($event: any) => ((coli.nbr_rtrn) = $event),
                                  title: "Nombre retourné"
                                }, null, 8, _hoisted_36), [
                                  [_vModelText, coli.nbr_rtrn]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((coli.open) = $event),
                              "true-value": 1,
                              "false-value": 0
                            }, null, 8, _hoisted_39), [
                              [_vModelCheckbox, coli.open]
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-sm",
                            title: "Supprimer",
                            onClick: ($event: any) => (_ctx.RemoveRow(coli))
                          }, _cache[26] || (_cache[26] = [
                            _createElementVNode("i", { class: "flaticon flaticon-delete fs-18" }, null, -1)
                          ]), 8, _hoisted_40)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (_ctx.load_add)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-primary fw-bold fs-13" }, "Enregistrement en cours...", -1)),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.progress) + "%", 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", {
                        class: "progress-bar progress-bar-striped progress-bar-animated",
                        role: "progressbar",
                        style: _normalizeStyle({ width: _ctx.progress + '%' }),
                        "aria-valuenow": _ctx.progress,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, null, 12, _hoisted_45)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.load_add || _ctx.ListColis.length === 0
                }, [
                  (_ctx.load_add)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(_ctx.load_add ? "Enregistrement..." : "Enregistrer les colis"), 1)
                ], 8, _hoisted_47)
              ])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}